import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';
import { AppContext } from 'commons-ui';
import useService from '../../../useService';
import { Record } from '../../../helper';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdatePlatformFeature } = useService();

	const createNewPlatformFeature = async (platformFeaturesData: Record) => {
		setShowLoader(true);
		try {
			const newPlatformFeaturesData: Record = { ...platformFeaturesData };
			const response: boolean = await requestUpdatePlatformFeature(newPlatformFeaturesData, showAlert);
			if (response) history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: Record) => {
		createNewPlatformFeature(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return {
		data: _get(location, ['state', 'rowData']),
		showLoader,
		handleFormSubmit,
		handleFormCancel,
		setShowLoader
	};
};

export default useCreate;
